function AvailabilityRuleDayDefinitionOfferMeedyVO(id, availabilityRule, day, startTime, endTime, stationary, videoConsultation,
                                                   tripCity, tripCity30km, dayDefinitionOffers) {

    this.id = id;
    this.availabilityRule = availabilityRule;
    this.day = day;
    this.startTime = startTime;
    this.endTime = endTime;
    this.stationary = stationary;
    this.videoConsultation = videoConsultation;
    this.tripCity = tripCity;
    this.tripCity30km = tripCity30km;
    this.dayDefinitionOffers = dayDefinitionOffers;

    var _typeContext = {
        dayDefinitionOffers: AvailabilityRuleDayDefinitionOfferMeedyVO,
        startTime: Date,
        endTime: Date,
        availabilityRule : AvailabilityRuleMeedyVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
